import { render, staticRenderFns } from "./acls.vue?vue&type=template&id=956125b2&"
import script from "./acls.vue?vue&type=script&lang=js&"
export * from "./acls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports